//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//
//

    const pulldownDefaultConfig = {
        content: '下拉刷新',
        height: 40,
        autoRefresh: false,
        downContent: '下拉刷新',
        upContent: '释放后刷新',
        loadingContent: '正在刷新...',
        clsPrefix: 'xs-plugin-pulldown-'
    }
    const pullupDefaultConfig = {
        content: '上拉加载更多',
        pullUpHeight: 60,
        height: 40,
        autoRefresh: false,
        downContent: '释放后加载',
        upContent: '上拉加载更多',
        loadingContent: '加载中...',
        clsPrefix: 'xs-plugin-pullup-'
    }
    export default {
        name: "baby_medication_list",
        data(){
            return{
                keyword: '',
                page: '1',
                listData: [],
                pullupDefaultConfig: pullupDefaultConfig,
                pulldownDefaultConfig: pulldownDefaultConfig,
                showDialog:false,
                group:{
                    feed_capacity: '',
                    milk_capacity: '',
                    water_capacity: '',
                    pee_times: '',
                    bowel_times: '',
                    bowel_condition: '',
                }
            }
        },
        methods:{
            //添加记录打开dialog
            addRecord(){
                this.showDialog = true
            },
            //添加记录确认
            dialog_confirm(){
                if(this.group.feed_capacity == ''){
                    this.$vux.toast.show({
                        type: 'cancel',
                        text: '请输入母乳量',
                    })
                    return
                }
                if(this.group.milk_capacity == ''){
                    this.$vux.toast.show({
                        type: 'cancel',
                        text: '请输入牛奶亮量',
                    })
                    return
                }
                if(this.group.water_capacity == ''){
                    this.$vux.toast.show({
                        type: 'cancel',
                        text: '请输入水',
                    })
                    return
                }
                if(this.group.pee_times == ''){
                    this.$vux.toast.show({
                        type: 'cancel',
                        text: '请输入小便次数',
                    })
                    return
                }
                if(this.group.bowel_times == ''){
                    this.$vux.toast.show({
                        type: 'cancel',
                        text: '请输入大便次数',
                    })
                    return
                }
                if(this.group.bowel_condition == ''){
                    this.$vux.toast.show({
                        type: 'cancel',
                        text: '请输入大便情况',
                    })
                    return
                }
                let params = {
                    token:this.$cookie.get('token'),
                    child_id:this.$route.query.child_id,
                    feed_capacity:this.group.feed_capacity,
                    milk_capacity:this.group.milk_capacity,
                    water_capacity:this.group.water_capacity,
                    pee_times:this.group.pee_times,
                    bowel_times:this.group.bowel_times,
                    bowel_condition:this.group.bowel_condition,
                }
                console.info(params)
                Api.babyLiveApi.addBabeFeedRecored(params).then ( res => {
                    console.info(res)
                    if(res.errcode == 1){
                        this.$vux.toast.show({
                            type: 'success',
                            text: res.errinfo,
                        })
                        this.showDialog = false
                        this.refresh()
                        this.group.feed_capacity = ''
                        this.group.milk_capacity = ''
                        this.group.water_capacity = ''
                        this.group.pee_times = ''
                        this.group.bowel_times = ''
                        this.group.bowel_condition = ''
                    }else{
                       this.$vux.toast.show({
                            type: 'cancel',
                            text: res.errinfo,
                        }) 
                    }
                })
            },
            //dialog隐藏
            dialog_exit(){
                this.showDialog = false
            },
            //时间戳转日期格式    
            formatDateTime(inputTime) {  
                var date = new Date(parseInt(inputTime)*1000)
                var y = date.getFullYear() 
                var m = date.getMonth() + 1  
                m = m < 10 ? ('0' + m) : m; 
                var d = date.getDate()
                d = d < 10 ? ('0' + d) : d
                var h = date.getHours()
                h = h < 10 ? ('0' + h) : h
                var minute = date.getMinutes()
                var second = date.getSeconds()
                minute = minute < 10 ? ('0' + minute) : minute 
                second = second < 10 ? ('0' + second) : second
                return y + '年' + m + '月' + d + '日' + h + ':' + minute + ':' + second
            },
            //清楚筛选
            clearSearch(){
                this.keyword = ''
                this.refresh()
            },
            //筛选
            searchBtn(){
                this.$nextTick(() => {
                    const scroller = this.getScrollerRef();
                    if (scroller) scroller.reset({top: 0});
                    this.refresh()
                })
            },
            //请求列表数据
            apiCheckRoomRecord(str){
                let params = {
                    token: this.$cookie.get('token'),
                    child_id:this.$route.query.child_id,
                    query: this.keyword,
                    page: this.page
                }
                console.info(params)
                Api.babyLiveApi.getBabeFeedRecored(params).then ( res => {
                    console.info(res)
                    if(res.errcode == 1){
                        this.page++
                        this.$nextTick(() => {
                            const scroller = this.getScrollerRef();
                            if (scroller) scroller.reset();
                        })
                        if(res.data.list.length){
                            for(let item of res.data.list){
                                let obj = {
                                    agent_id: item.agent_id,
                                    bowel_condition: item.bowel_condition,
                                    bowel_times: item.bowel_times,
                                    breast_milk_id: item.breast_milk_id,
                                    child_id: item.child_id,
                                    create_time: item.create_time,
                                    feed_capacity: item.feed_capacity,
                                    id:item.id,
                                    milk_capacity:item.milk_capacity,
                                    overplus_milk:item.overplus_milk,
                                    pee_times:item.pee_times,
                                    store_id:item.store_id,
                                    user_name:item.user_name,
                                    water_capacity:item.water_capacity
                                }
                                this.listData.push(obj)
                            }
                            const scroller = this.getScrollerRef();
                            if (scroller) {
                                scroller.donePullup();
                                if(str == 'refresh'){
                                    scroller.enablePullup();
                                    scroller.donePulldown();
                                }
                                if( this.page > res.data.page.page_count){
                                    // 禁用上拉加载，在没有更多数据时执行
                                    scroller.disablePullup();
                                }
                            }
                        }
                    }else{
                        this.listData = []
                        this.$vux.toast.show({
                            type: 'cancel',
                            text: res.errinfo,
                        })
                    }
                })
            },
            //下拉刷新
            refresh() {
                this.listData.length = 0
                this.page = '1'
                this.apiCheckRoomRecord('refresh')
            },
            //上拉加载
            loadMore() {
                this.apiCheckRoomRecord()
            },
            //获取当前可见的scroller ref
            getScrollerRef() {
                return this.$refs.scrollerBottom || this.$refs.scrollerMobile;
            },
            goBack(){
                this.$router.push({
                    path: './maternal_service',
                    query: {
                        tabVal: this.$route.query.tabVal,
                        id: this.$route.query.id
                    }
                })
            }
        },
        mounted (){
            this.$nextTick(() => {
                const scroller = this.getScrollerRef();
                if (scroller) scroller.reset({top: 0});
            })
            this.apiCheckRoomRecord()
        }
    }



// WEBPACK FOOTER //
// ./src/components/baby_feed_list.vue